import { SvgIcon, SvgIconProps } from '@mui/material';
import DownIcon from '../../../../icons/svg/arrow_down.svg?react';
import PreviousIcon from '../../../../icons/svg/arrow_left.svg?react';
import NextIcon from '../../../../icons/svg/arrow_right.svg?react';
import CalendarIcon from '../../../../icons/svg/calendar.svg?react';

type IconProps = Omit<SvgIconProps, 'component' | 'color'>;

export const Previous = (props: IconProps): JSX.Element => (
  <SvgIcon {...props} component={PreviousIcon} color="primary" />
);

export const Next = (props: IconProps): JSX.Element => (
  <SvgIcon {...props} component={NextIcon} color="primary" />
);

export const Down = (props: IconProps): JSX.Element => (
  <SvgIcon {...props} component={DownIcon} color="primary" />
);

export const Calendar = (props: IconProps): JSX.Element => (
  <SvgIcon {...props} component={CalendarIcon} color="primary" />
);
